import styled, { keyframes } from 'styled-components/macro'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

export const productsVariants = {
    initial: {
        opacity: 0
    },
    animate: {
       opacity: 1
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .1
        }
    }
}

export const ProductsContainer = styled(motion.div)`
    width: 100%;
    min-heigh: 32rem;
    margin: 3rem auto 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
`

export const ProductsTitle = styled(motion.h2)`
    color: white;
`

export const ProductsInner = styled(motion.div)`
    width: 90%;
    height: 25rem;
    margin: 2rem auto 0 auto;
    display: flex;
    justify-content: center;

    @media all and (max-width: 650px) {
        margin-left: 10%;
    }
`

export const ProductsListViewer = styled.div`
    width: 90%;
    height: 25rem;
`

export const Inner = styled(motion(Link))`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
`


export const SlideImage = styled.img`
    width: 100%;
    max-height: 16rem;
    object-fit: contain;
`

export const ProductName = styled.p`
font-weight: bold;
    width: 100%;
    text-align: center;
    border-top: 1px solid var(--secondary-color);
    margin-top: 1rem;
    padding-top: .5rem;
    height: 4rem;
`

//SKELETON
const load = keyframes`
    from { left: -100%}
    to { left: 100%;}
`

export const Skeleton = styled.div`
    width: 100%;
    height: 24rem;
    border-radius: 15px;
    position: relative;
    overflow: hidden;

    &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: -100%;
        height: 100%;
        width: 100%;
        background: linear-gradient(to right, white 0%, #E8E8E8 50%, white 100%);
        animation: ${load} 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
    }
`